<template>
  <div class="legal-info-page container">
    <Title class="mb30" current-name="Контакты">
      Юридическая информация
    </Title>
    <ul class="legal-info-page_links">
      <li>
        <nuxt-link to="/legal-info/agreement">
          Пользовательское соглашение
        </nuxt-link>
      </li>
      <li>
        <nuxt-link to="/legal-info/personal-politic">
          Политика обработки персональных данных
        </nuxt-link>
      </li>
      <li>
        <nuxt-link to="/legal-info/oferta">
          Договор оферты
        </nuxt-link>
      </li>
      <li>
        <nuxt-link to="/legal-info/promotions-description">
          Акции. Правовое описание
        </nuxt-link>
      </li>
      <li>
        <nuxt-link to="/legal-info/terms-of-payment-and-delivery">
          Условия оплаты, доставки, возврата товаров
        </nuxt-link>
      </li>
    </ul>
  </div>
</template>

<script>
import Title from '~/components/UI/Title.vue'

export default {
  components: { Title },
}
</script>
